<template>
  <v-layout column fill-height justify-center align-center>
    <div v-if="getImage" @click="clickHandler" :style="`cursor: pointer; height: 100%; width: 100%; backgroundImage: url(${this.getImage}); backgroundSize: contain; background-position: center top`"></div>
    <v-icon v-if="!getImage && this.edit" size="112" class="image-wrap" style="cursor: pointer;" @click="clickHandler">add_photo_alternate</v-icon>
    <input v-if="!clear" ref="image-input" class="button-file-upload__input" type="file" title=" " accept @change="(e) => onImageSelect(e)" style="visibility: hidden; position: absolute" >
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import uid from '@/nms/components/utils/uid'

interface ImageData {
  url?: string
  [key: string]: any
}

interface ComponentData {
  [key: string]: any
}

export default Vue.extend({
  
  name: 'FILE_IMAGE',

  props: {
    data: {
      type: Object as () => ComponentData,
      default: () => ({})
    },
    image: {
      type: Array as () => ImageData[],
      default: () => []
    },
    edit: {
      type: Boolean,
      default: false
    },
  },

  data(): {
    id: string
    clear: boolean
  } {
    return {
      id: uid('image'),
      clear: false,
    }
  },

  computed: {
    getData(): ComponentData {
      return this.data
    },

    getImage(): string | undefined {
      if (!this.image.length) return undefined
      return this.image[0].url
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {},

    clickHandler(): void {
      if (this.edit) {
        const input = this.$refs['image-input'] as HTMLInputElement
        if (input) {
          input.click()
        }
      }
    },

    onImageSelect(e: Event): void {
      console.log('IMAGE', e)
      this.$emit('select', e)
      this.reset()
    },

    reset(): void {
      this.clear = true
      this.$nextTick(() => {
        this.clear = false
      })
    },
  },
})
</script>

<style lang="css" scoped>

.image-wrap {

  box-sizing: border-box;
  color: grey;

}

.image-wrap:hover {

  color: white;

}

</style>
